import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1ov944qwit: FaireBrandEntity = {
  token: "b_1ov944qwit",
  type: "brand",
  name: "Oyin Handmade",
  avatarUrl:
    "https://cdn.faire.com/fastly/9a1bd035414b5f88882a971dc4fde1191c44b69cd7cb5258df692d0c81df9ba1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/24252064b69b259a3725dd94548bb32da2d3cf4c7e866eb8220279d3a6aacb8c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9a1bd035414b5f88882a971dc4fde1191c44b69cd7cb5258df692d0c81df9ba1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/24252064b69b259a3725dd94548bb32da2d3cf4c7e866eb8220279d3a6aacb8c.jpeg",
  location: "Baltimore, MD, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 24,
  isInsider: true,
  description:
    "Oyin Handmade is an artisanal manufacturer of moisture-rich personal care products, formulated especially for highly textured hair and dry skin. \n\nSince 2003,  we have used food-grade ingredients to create high-performance hair and body goodies with clean, good-for-you formulas. We use no sulfates, no parabens, no silicones, no phthalates, and never test on animals. We're unisex, family-friendly, and made with love. \n\nOyin (“oy-yeen”) is the Yoruba word for honey! This ingredient is an incredible natural hydrating ingredient for dry hair, and also reminds us of sweetness, love, and joy - the feelings we seek to inspire in the everyday acts of self-care.\n\nOur goal is healthy, happy hair and skin.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:59.074Z",
    importedBy: "entity-db-cli",
  },
};
